import { Icon } from "@/styles/Icon";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const ViewAllButton: React.FC<{ href?: string; children?: React.ReactNode }> = ({ 
  href = '/explore', 
  children = 'View All' 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(href);
  };

  return (
    <ViewAllButtonStyled onClick={handleClick}>
      <span>{children}</span>
      <Icon name="arrowRight" size={24} />
    </ViewAllButtonStyled>
  );
};

export { ViewAllButton };

const ViewAllButtonStyled = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  
  color: ${({ theme }) => theme.colors.fontBlackText};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;
  text-decoration: underline;
  text-decoration-style: solid;
  text-underline-position: from-font;
  
  transition: all 0.2s ease;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    
    img {
      transform: translateX(4px);
    }
  }
  
  img {
    transition: transform 0.2s ease;
  }
`;